'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const tslib_es6 = require('../tslib.es6-CZ43up4V.js');
const jsxRuntime = require('react/jsx-runtime');
const React = require('react');
const reactAriaComponents = require('react-aria-components');
const Label_LabelRequiredText = require('./LabelRequiredText.cjs.js');

const label = "_label_ol4dq_1";
const asterisk = "_asterisk_ol4dq_19";
const styles = {
	label: label,
	asterisk: asterisk
};

const LabelContext = React.createContext(null);
const Label = (props) => {
  const [contextProps] = reactAriaComponents.useContextProps(props, null, LabelContext);
  const { children, isCompact, isDisabled, isInvalid, isRequired, requiredText = "required" } = contextProps, domProps = tslib_es6.__rest(contextProps, ["children", "isCompact", "isDisabled", "isInvalid", "isRequired", "requiredText"]);
  return jsxRuntime.jsxs(reactAriaComponents.Label, Object.assign({}, domProps, { className: styles.label, "data-compact": isCompact, "data-state": [isInvalid && "invalid", isDisabled && "disabled"].filter(Boolean).join(" ") || void 0, "data-zds": true, children: [children, isRequired && jsxRuntime.jsx("abbr", { className: styles.asterisk, title: "required", children: "*" }), isRequired && requiredText && jsxRuntime.jsx(Label_LabelRequiredText.LabelRequiredText, { isDisabled, children: requiredText })] }));
};

exports.Label = Label;
exports.LabelContext = LabelContext;
//# sourceMappingURL=Label.cjs.js.map
